/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-06-27 17:22:10
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-08 18:03:56
 */
import OmegaTracker from '@didi/omega-tracker-lite';

/**
 * 事件的属性
 */
export interface IAttrs {
  [k: string]: any;
}

// 初始化设置appKey 及其他属性
// http://omega.xiaojukeji.com/omegabook/omega/overview.html
const Omega = OmegaTracker.getTracker({
  appKey: 'omega67e0b89ccc', // appkey
  uploadHost: 'omgup.didiglobal.com', // 上报地址
  autoSendPageView: false // 改为分路由手动上报PV
});

export default {
  Omega,
  trackEvent: (eventId: string, eventLabel?: string | IAttrs, attrs?: IAttrs) => {
    const loginInfo: any = JSON.parse(sessionStorage.getItem('userAuth') || '{}')?.login_info;

    return (
      Omega &&
      Omega.trackEvent(eventId, eventLabel, {
        user_id: loginInfo?.uid,
        country_code: loginInfo?.country_code,
        ...attrs
      })
    );
  },
  setConfig: (config: any) => Omega && Omega.setConfig(config),
  sendPageView: () => Omega && Omega.sendPageView(),
  trackBusiness: (eventId: any, { business, type, status, msg, params }: any) => {
    try {
      const omegaParams = {
        business,
        type,
        status,
        msg,
        params: JSON.stringify(params)
      };

      Omega && Omega.trackEvent(eventId, '通用业务埋点', omegaParams);
    } catch (err) {
      console.log('omega上报错误');
    }
  }
};
